import { render, staticRenderFns } from "./ActiveProcessMaster.vue?vue&type=template&id=01bbee36&scoped=true&"
import script from "./ActiveProcessMaster.vue?vue&type=script&lang=js&"
export * from "./ActiveProcessMaster.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProcessMaster.vue?vue&type=style&index=0&id=01bbee36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbee36",
  null
  
)

export default component.exports